var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"wrapper"},[_c('EditPanel',{ref:"editPanel",attrs:{"baseInfo":_vm.baseInfo}}),_c('section',{staticClass:"wrapper-footer"},[_c('EditFooter',{attrs:{"getModifyData":_vm.getModifyData,"baseInfo":_vm.baseInfo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }